import { NonPerformanceCode as GqlNonPerformanceCode } from '@willow/graphql-iso/src/app';
import { NonPerformanceCode } from '@willow/types-iso';

export const GqlNonPerformanceCodeToNonPerformanceCode: Record<GqlNonPerformanceCode, NonPerformanceCode> = {
  AppealOfLoanModification: 'Appeal of Loan Modification',
  Assignment: 'Assignment',
  Assumption: 'Assumption',
  BPOAppraisalObtained: 'BPO/Appraisal Obtained',
  BPOOrdered: 'BPO Ordered',
  BankruptcyCourtClearanceObtainedStayLifted: 'Bankruptcy Court Clearance Obtained/Stay Lifted',
  BankruptcyCramdownScheduled: 'Bankruptcy Cramdown Scheduled',
  BankruptcyDischargedNoReaffirmation: 'Bankruptcy Discharged No Reaffirmation',
  BankruptcyDischargedReaffirmation: 'Bankruptcy Discharged Reaffirmation',
  BankruptcyPlanConfirmed: 'Bankruptcy Plan Confirmed',
  BankruptcyPropertySurrendered: 'Bankruptcy–Property Surrendered',
  BorrowerDeclinedLossMitigationConsultation: 'Borrower Declined Loss Mitigation Consultation',
  BorrowerParticipatedInLossMitigationConsultation: 'Borrower Participated in Loss Mitigation Consultation',
  BreachLetterSent: 'Breach Letter Sent',
  Chapter7AssetCase: 'Chapter 7 Asset Case',
  Chapter7Bankruptcy: 'Chapter 7 Bankruptcy',
  Chapter11Bankruptcy: 'Chapter 11 Bankruptcy',
  Chapter12Bankruptcy: 'Chapter 12 Bankruptcy',
  Chapter13Bankruptcy: 'Chapter 13 Bankruptcy',
  Chapter13BankruptcyPlanPostPetition: 'Chapter 13 Bankruptcy Plan - Post-Petition Period Utilize',
  ChargeOff: 'Charge‑off',
  CombinationLoanModificationAndPartialClaim40Year: 'Combination Loan Modification and Partial Claim 40 Year',
  CompleteBorrowerResponsePackage: 'Complete Borrower Response Package',
  CompleteLossMitigationRequestReceived: 'Complete Loss Mitigation Request Received',
  ContestedLitigatedForeclosure: 'Contested/Litigated Foreclosure',
  DateAdvisedPropertyListedForSale: 'Date Advised Property Listed for Sale',
  DateOfFirstLegalAction: 'Date of First Legal Action',
  DateOfFirstQRPC: 'Date of First QRPC',
  DateOfLastQRPC: 'Date of Last QRPC',
  DelinquentNoAction: 'Delinquent—No Action',
  DisasterForbearance: 'Disaster Forbearance',
  DrugSeizure: 'Drug Seizure',
  FederalLawMandatedDelay: 'Federal Law Mandated Delay',
  Forbearance: 'Forbearance',
  Foreclosure: 'Foreclosure',
  ForeclosureMediation: 'Foreclosure Mediation',
  ForeclosureSaleContinued: 'Foreclosure Sale Continued',
  ForeclosureSaleScheduled: 'Foreclosure Sale Scheduled',
  GovernmentSeizure: 'Government Seizure',
  IneligibleCancelModification: 'Ineligible/Cancel Modification',
  IneligibleForShortSale: 'Ineligible for Short Sale',
  JudgmentOrDecreeEntered: 'Judgment or Decree Entered',
  LossMitigationRequestDenied: 'Loss Mitigation Request Denied',
  MilitaryIndulgence: 'Military Indulgence',
  Modification: 'Modification',
  ModificationInReview: 'Modification in Review',
  ModificationStarted40Year: 'Modification Started 40 Year',
  MortgageRelease: 'Mortgage Release',
  OutsideOfWaterfallLoanModification: 'Outside of Waterfall Loan Modification',
  PaymentDeferralOffer: 'Payment Deferral Offer',
  PreFileMediation: 'Pre-File Mediation/ Mediation',
  Probate: 'Probate',
  QualityRightPartyContact: 'Quality Right Party Contact',
  Refinance: 'Refinance',
  Reinstatement: 'Reinstatement',
  ReinstatedExemptedTransfer: 'Reinstated Exempted Transfer',
  ReinstatedExemptedTransferAfterLossMitigation: 'Reinstated Exempted Transfer after Loss Mitigation',
  RepaymentPlan: 'Repayment Plan',
  RepaymentPlanInReview: 'Repayment Plan in Review',
  SecondLienConsiderations: 'Second Lien Considerations',
  ShortSaleApprovedMarketingProperty: 'Short Sale Approved/Marketing Property',
  ShortSaleApprovedOfferReceived: 'Short Sale Approved/Offer Received',
  ShortSaleInReview: 'Short Sale in Review',
  SolicitationLetterSent: 'Solicitation Letter Sent',
  StateMandatedDelay: 'State Mandated Delay',
  ThirdPartySale: 'Third‑Party Sale',
  TitleIssueInProgress: 'Title Issue in Progress',
  TrialModification: 'Trial Modification',
  TrialPaymentPlanCombinationLoanModificationPartialClaim:
    'Trial Payment Plan Combination Loan Modification/Partial Claim',
  TrialPaymentPlanExemptedTransfer: 'Trial Payment Plan Exempted Transfer',
  TrialPaymentPlanOutsideOfWaterfallLoanModification: 'Trial Payment Plan Outside of Waterfall Loan Modification',
  TrialPaymentPlanPaymentSupplement: 'Trial Payment Plan Payment Supplement',
  TrialPaymentPlanStandaloneLoanModification: 'Trial Payment Plan Standalone Loan Modification',
  TrialPaymentPlanStandalonePartialClaim: 'Trial Payment Plan Standalone Partial Claim',
  VABuydown: 'VA—Buydown',
  VANoBid: 'VA—No Bid',
  VARefund: 'VA—Refund',
  VeteransAffairsRefund: 'Veterans Affairs—Refund',
  WorkoutInReview: 'Workout in Review',
} as const;
